var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Menu, MenuItem, translate, XCircleIcon } from '@lucidlink/uicore';
import { useDeclineInvitationFlow } from '#hooks';
export const WorkspacePendingMenuContents = ({ workspace: { id: workspaceId, name: workspaceName }, }) => {
    _react_refresh_temp_2();
    const showDeclineInvitationModal = useDeclineInvitationFlow({
        workspaceId,
        workspaceName,
    });
    return (_jsx(Box, { gap: "s", kind: "level3", orientation: "vertical", padding: "s", radius: "m", children: _jsx(Menu, { navigationType: "arrows", children: _jsx(MenuItem, { "data-testid": "decline-invitation", LeadingIcon: XCircleIcon, onClick: showDeclineInvitationModal, text: translate('Decline invite') }) }) }));
};
_react_refresh_temp_1 = WorkspacePendingMenuContents;
$RefreshReg$(_react_refresh_temp_1, "WorkspacePendingMenuContents");
_react_refresh_temp_2(WorkspacePendingMenuContents, "u//7FmduyF0EC3LOZOq624BE3bc=", false, () => [useDeclineInvitationFlow]);
